/**
 * CMCD event mode variable name.
 *
 * @group CMCD
 *
 * @beta
 */
export const CMCD_EVENT_MODE = 'event';
//# sourceMappingURL=CMCD_EVENT_MODE.js.map